import React from 'react';
import { useAuthStore } from 'stores/authStore';
import { DASHBOARD } from 'constants/routes';
import useQuery from 'hooks/useQuery';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

export function LoginRoute({ children }) {
  const query = useQuery();
  const location = useLocation();
  const redirect = query.get('redirectUrl');
  const user = useAuthStore((state) => state.user);

  if (user?.email) {
    const to = redirect || { pathname: DASHBOARD, state: { from: location } };
    return <Navigate to={to} replace />;
  }

  return children;
}

LoginRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
